import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import Box from "@mui/material/Box";
import ReportSection from "./ReportSection";
import DispatchedJobIdTransferData from "./DispatchedJobIdTransferData";
import Availablejobs from "./Availablejobs";
import AmsUpdateReport from "./ReviwerActionInCsrSheet/AmsUpdateReport";
import GridBackUpSection from "./GridBackUpSection";
import JobConfigurations from "./JobConfigurations";
import { processAndUpdateToken } from "../Services/CommonFunctions";
import axios from "axios";
import { baseUrl } from "../Services/Constants";

const DeletionReport = (props) => {
  const [msgVisible, setMsgVisible] = useState(false);
  const [msgClass, setMsgClass] = useState("");
  const [msgText, setMsgText] = useState("");
  const [activeTab, setActiveTab] = useState("table1");
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [deletionConfig, setDeletionConfig] = useState("");

  const getUserRole = async () => {
    var token = sessionStorage.getItem("token");
    const UserName = sessionStorage.getItem("userName");
    const updatedToken = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${updatedToken}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + "/api/Defaultdatum/GetUserRole?userName=" + `${UserName}`,
      { headers }
    );
    setDeletionConfig(response?.data?.DeletionConfig);
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    getUserRole();
  }, []);

  return (
    <>
      {role.includes("DeletionReport") ? (
        <div>
          <div style={{ width: "100%" }}>
            <div className="app-container">
              <div style={{ padding: "5px", width: "95%" }}>
                {msgVisible && (
                  <div className="alert-container">
                    <div className={msgClass}>{msgText}</div>
                  </div>
                )}
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                  >
                    <Tab
                      label="DELETION REPORT"
                      value="table1"
                      style={{ backgroundColor: "white !important" }}
                    />
                    {deletionConfig?.includes("table4") &&
                    <Tab
                      label="Transfer Data"
                      value="table4"
                      style={{ backgroundColor: "white !important" }}
                    />}
                    {deletionConfig?.includes("table2") &&
                      <Tab
                        label="Backup Records"
                        value="table2"
                        style={{ backgroundColor: "white !important" }}
                      />}
                    {deletionConfig?.includes("table5") &&
                      <Tab
                        label="Job Configuration"
                        value="table5"
                        style={{ backgroundColor: "white !important" }}
                      />}
                    <Tab
                      label="Available Jobs"
                      value="table3"
                      style={{ backgroundColor: "white !important" }}
                    />
                  </Tabs>
                </Box>
                <div>
                  {activeTab == "table1" && (
                    <ReportSection activeTab={activeTab} />
                  )}
                  {activeTab == "table2" && <DispatchedJobIdTransferData />}
                  {activeTab == "table3" && <Availablejobs />}
                  {activeTab === "table4" && <GridBackUpSection />}
                  {activeTab === "table5" && <JobConfigurations />}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default DeletionReport;
